export default __webpack_public_path__ + "static/media/Golden_Wall_LE.4d053108.jpg";